module.exports = __webpack_public_path__ + "static/img/img-fm-price.499e19f8.png";